import type { RootState } from '@store';

export const loginSelector = (state: RootState) => state.login;
